<script>
import Socials from './SaleSocials';

export default {
  name: 'SaleHeader',
  components: { Socials },
  data() {
    return {
      now: null,
    };
  },
  props: {
    currentStage: {
      type: Number,
      default: 0,
    },
    saleStartTimestamp: {
      type: Number,
      default: 0,
    },
    nextStageDate: {
      type: String,
      default: '',
    },
    saleStartDate: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '-',
    },
    product: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    countdown() {
      const { now } = this;
      const dateStr = this.notStartedYet ? this.saleStartDate : this.nextStageDate;
      const stageDate = new Date(dateStr);
      const diff = stageDate - now > 0 ? stageDate - now + 60000 : 0;
      const days = Math.floor(diff / 1000 / 3600 / 24);
      const hours = Math.floor((diff / 1000 / 3600) % 24);
      const minutes = Math.floor((diff / 1000 / 60) % 60);
      return {
        d: days,
        h: hours,
        m: minutes,
      };
    },
    notStartedYet() {
      return this.saleStartTimestamp ? +new Date() / 1000 < this.saleStartTimestamp : true;
    },
  },
  mounted() {
    window.setInterval(() => {
      this.now = new Date();
    }, 1000);
  },
  methods: {
    getIconSrc() {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`@/assets/img/${this.$chain.getName()}/launchpad/${this.product.icon}.jpg`);
    },
  },
};
</script>

<template>
  <div class="d-flex justify-space-between mb-5">
    <div class="d-flex align-center flex-grow-1">
      <div class="upcoming-card__icon">
        <img :src="getIconSrc()" />
      </div>
      <div class="ml-5 d-block d-sm-flex justify-space-between flex-grow-1">
        <div>
          <div class="d-flex align-center mb-3 justify-end justify-sm-start">
            <span
              class="upcoming-card__title font-weight-bold mr-4"
              v-html="name ? name : product.name"
            >
            </span>
            <span
              class="upcoming-card__step"
              v-if="currentStage < 2 && !product.isFinished && notStartedYet"
            >
              {{ $t('upcoming.upcoming') }}
            </span>
            <span
              class="upcoming-card__step upcoming-card__step--green"
              v-else-if="currentStage > 0 && currentStage < 4 && !product.isFinished"
              >{{ $t('upcoming.live') }}</span
            >
            <span class="upcoming-card__step upcoming-card__step--red" v-else>{{
              $t('upcoming.closed')
            }}</span>
          </div>
          <div class="footer__social justify-sm-start justify-end">
            <Socials
              v-for="(social, index) in product.socialLinks"
              :key="index"
              :social="social"
            />
          </div>
        </div>
        <div
          class="mt-2 upcoming-card__start text-sm-left text-right"
          v-if="[2, 3].includes(currentStage) || (notStartedYet && saleStartTimestamp)"
        >
          <p class="upcoming-card__countdown">
            {{ $t('upcoming.starts') }}
            {{ countdown.d }}d {{ countdown.h }}h {{ countdown.m }}m
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.upcoming-card {
  &__icon {
    body.binance & {
      color: $b-secondatry-font-color;
      background: $b-main-bg;
      box-shadow: $b-pools-select-shadow;
    }
  }

  &__step {
    body.binance & {
      color: $b-secondatry-font-color;
      background: $b-main-bg;
      box-shadow: $b-pools-select-shadow;
    }
  }

  &__countdown {
    body.binance & {
      color: $b-binance-color;
    }
  }
}
</style>
